import { render } from "./AppRibbon.vue?vue&type=template&id=ddac4d9e"
import script from "./AppRibbon.vue?vue&type=script&lang=js"
export * from "./AppRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__